import benz from "../assest/Brand-logo/benz.png";
import audi from "../assest/Brand-logo/audi.png";
import bmw from "../assest/Brand-logo/bmw.png";
import changane from "../assest/Brand-logo/changan.png";
import chevy from "../assest/Brand-logo/chevy.png";
import fiat from "../assest/Brand-logo/fiat.png";
import firari from "../assest/Brand-logo/firari.png";
import honda from "../assest/Brand-logo/honda.png";
import hyndai from "../assest/Brand-logo/hyundai.png";
import infinity from "../assest/Brand-logo/infinity.png";
import kia from "../assest/Brand-logo/kia.png";
import lamborgini from "../assest/Brand-logo/lambargini.png";
import land from "../assest/Brand-logo/land.png";
import lexsus from "../assest/Brand-logo/lexus.png";
import mazda from "../assest/Brand-logo/mazda.png";
import mitsubishi from "../assest/Brand-logo/mitsubishi.png";
import nissan from "../assest/Brand-logo/nissan.png";
import opel from "../assest/Brand-logo/opel.png";
import porsche from "../assest/Brand-logo/porsche.png";
import toyota from "../assest/Brand-logo/toyota.jpg";
import volswagen from "../assest/Brand-logo/volswagen.jpg";

const DataUse=[
     {name:"toyota",image:toyota},{name:"nissan",image:nissan},
     {name:"kia",image:kia},{name:"honda",image:honda},{name:"hyndai",image:hyndai}
     ,{name:"lexsus",image:lexsus},{name:"volswagen",image:volswagen},
     {name:"mazda",image:mazda},{name:"infinity",image:infinity},{name:"Mercedes",image:benz}
     ,{name:"audi",image:audi},{name:"bmw",image:bmw},{name:"changan",image:changane},
     {name:"chevy",image:chevy},{name:"fiat",image:fiat},{name:"porsche",image:porsche}
     ,{name:"opel",image:opel},{name:"mitsubishi",image:mitsubishi},{name:"landRover",image:land},
     {name:"lamborgini",image:lamborgini},{name:"firrari",image:firari}
]

export default  DataUse

